import React from 'react';
import { useApp } from '../../context/AppContext';
import Header from './Header';
import LogoLockup from '../shared/LogoLockup';

const Layout = ({ children }) => {
  const { loading } = useApp();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F7F4EE] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <LogoLockup size="lg" className="animate-pulse" />
          <div className="text-center">
            <p className="text-sm text-[#5A5A5A]">Loading your care dashboard...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full max-w-full overflow-x-hidden bg-[#F7F4EE]">
      {/* Top Header */}
      <Header />
      
      {/* Page Content */}
      <main className="min-w-0 max-w-full animate-fade-in overflow-x-hidden">
        {children}
      </main>
    </div>
  );
};

export default Layout;
